import React, { useState, useEffect } from "react";

import styles from "./devUpdateForm.module.scss";
import authService from "../../../utils/services/authService";
import { techStack } from "../../../utils/data/techStack";
import { formatData } from "../../../utils/helper-functions/devProfile";
import { useNavigate } from "react-router-dom";

const DevUpdateForm = ({ userData }) => {
  const [user, setUser] = useState({
    phone: "",
    profession: [],
    location: "",
    languages: [],
    education: "",
    gender: "",
    skills: [],
    bio: "",
    socials: {
      linkedIn: "",
      github: "",
    },
    preferences: {
      minSalary: "",
      locations: [],
      role: [],
      officePref: [],
      jobTypes: [],
    },
    createdProfile: false,
  });

  //Search mechanic states
  const [searchField, setSearchField] = useState("");
  const [stack, setStack] = useState(techStack);
  const [filteredStack, setFilteredStack] = useState(stack);

  //state for selected tech
  const [selectedTech, setSelectedTech] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (userData.createdProfile) {
      navigate(`/profile/developer/${userData.userId}`);
    }
  }, []);

  useEffect(() => {
    const filteredStack = stack.filter((tech) => {
      return tech.name.toLowerCase().includes(searchField);
    });
    setFilteredStack(filteredStack);
  }, [stack, searchField]);

  useEffect(() => {
    setUser({ ...user, skills: selectedTech });
  }, [selectedTech]);

  const onSearchChange = (e) => {
    const searchFieldString = e.target.value.toLowerCase();
    setSearchField(searchFieldString);
  };

  //If nestedObj is === 'preferences' or 'socials' insert the value in its correct nested objects. Else insert it by the name attribute.
  const onChangeHandle = (e, nestedObj) => {
    const value = e.target.value;
    if (nestedObj === "socials") {
      setUser({
        ...user,
        socials: { ...user.socials, [e.target.name]: value },
      });
    } else if (nestedObj === "preferences") {
      setUser({
        ...user,
        preferences: { ...user.preferences, [e.target.name]: value },
      });
    } else {
      setUser({ ...user, [e.target.name]: value });
    }
  };

  const techOnClickHandle = (e) => {
    const selected = e.target.getAttribute("data-value");

    if (selectedTech.includes(selected)) {
      return;
    } else {
      setSelectedTech([...selectedTech, selected]);
    }
  };

  const selectedOnClickHandle = (e) => {
    const remove = e.target.getAttribute("data-value");
    const clearedItems = selectedTech.filter((selected) => selected !== remove);
    setSelectedTech(clearedItems);
    setUser({ ...user, skills: clearedItems });
  };

  const stringToArray = (obj) => {
    let newObject = { ...obj };
    const keys = Object.keys(newObject);
    formatData(newObject, keys);

    return newObject;
  };

  const onSubmitHandle = async (e) => {
    e.preventDefault();
    const formData = stringToArray({ ...user });

    formData.createdProfile = true;
    console.log(formData);
    const result = await authService.updateUser(
      userData.role,
      userData.userId,
      formData,
      userData
    );
    if (result?.data.success) {
      if (result.data.data.createdProfile) {
        updateLocalStorage();
        navigate(`/profile/developer/${userData.userId}`);
      }
    }
  };
  const updateLocalStorage = () => {
    const ls = JSON.parse(localStorage.getItem("userData"));
    ls.createdProfile = true;
    localStorage.setItem("userData", JSON.stringify(ls));
  };

  return (
    <section className={styles.formWrapper}>
      <h1 className={styles.formWrapper_heading}>Update your profile</h1>
      <p className={styles.formWrapper_subHeading}>
        You need to fill out everything to continue
      </p>
      <form className={styles.updateForm} action="">
        <h3 className={styles.updateForm_heading}>Basic info</h3>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="phone">
            Phone number
          </label>
          <input
            id="phone"
            name="phone"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g 0707-123 456"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="profession">
            Profession &#40;if more than one, separate with comma&#41;
          </label>
          <input
            id="profession"
            name="profession"
            className={styles.formGroup_input}
            type="text"
            placeholder="Fullstack developer, backend developer"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="location">
            Location
          </label>
          <input
            id="location"
            name="location"
            className={styles.formGroup_input}
            type="text"
            placeholder="Stockholm"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="languages">
            Languages &#40;if more than one, separate with comma&#41;
          </label>
          <input
            id="languages"
            name="languages"
            className={styles.formGroup_input}
            type="text"
            placeholder="English, Swedish"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="education">
            Education
          </label>
          <input
            id="education"
            name="education"
            className={styles.formGroup_input}
            type="text"
            placeholder="Name of your school"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="gender">
            Gender
          </label>
          <select
            name="gender"
            id="gender"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          >
            <option defaultValue={""} value="">
              Choose gender
            </option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Prefer not to say">Prefer not to say</option>
          </select>
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="skills">
            Programming languages
          </label>
          <input
            id="skills"
            className={styles.formGroup_input}
            type="search"
            // tabIndex="3"
            aria-label="Search tech and choose from list below"
            placeholder="Search and choose your tech"
            onChange={(e) => {
              onSearchChange(e);
            }}
          />
          <div className={styles.displayStack}>
            <p>Click on the items to select tech</p>
            <div className={styles.itemsWrapper}>
              {filteredStack.map((tech, index) => (
                <span
                  key={index}
                  data-value={tech.name}
                  className={`${styles.itemsWrapper_item}`}
                  onClick={(e) => {
                    techOnClickHandle(e);
                  }}
                >
                  {tech.name}
                </span>
              ))}
            </div>
          </div>
          <div className={styles.techSelectedWrapper}>
            <p>You've chosen</p>
            <div className={styles.techSelected}>
              {selectedTech.map((selected, index) => (
                <span
                  key={index}
                  data-value={selected}
                  className={styles.techSelected_item}
                  onClick={(e) => {
                    selectedOnClickHandle(e);
                  }}
                >
                  {selected}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="bio">
            Biography
          </label>
          <textarea
            id="bio"
            name="bio"
            className={styles.formGroup_textArea}
            type="text"
            onChange={(e) => {
              onChangeHandle(e, "");
            }}
          ></textarea>
        </div>
        <h3 className={styles.updateForm_heading}>Socials</h3>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="github">
            Github
          </label>
          <input
            id="github"
            name="github"
            className={styles.formGroup_input}
            type="text"
            placeholder="Github link"
            onChange={(e) => {
              onChangeHandle(e, "socials");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="linkedIn">
            LinkedIn
          </label>
          <input
            id="linkedIn"
            name="linkedIn"
            className={styles.formGroup_input}
            type="text"
            placeholder="LinkedIn profile link"
            onChange={(e) => {
              onChangeHandle(e, "socials");
            }}
          />
        </div>
        <h3 className={styles.updateForm_heading}>Preferences</h3>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="minSalary">
            Minimum salary
          </label>
          <input
            id="minSalary"
            name="minSalary"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g 30 000"
            onChange={(e) => {
              onChangeHandle(e, "preferences");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="locations">
            Locations &#40;if more than one, separate with comma&#41;
          </label>
          <input
            id="locations"
            name="locations"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g Stockholm, Malmö"
            onChange={(e) => {
              onChangeHandle(e, "preferences");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="role">
            Role &#40;if more than one, separate with comma&#41;
          </label>
          <input
            id="role"
            name="role"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g Fullstack, Frontend, Backend"
            onChange={(e) => {
              onChangeHandle(e, "preferences");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="officePref">
            Remote preferences &#40;if more than one, separate with comma&#41;
          </label>
          <input
            id="officePref"
            name="officePref"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g Remote, In-house, Hybrid"
            onChange={(e) => {
              onChangeHandle(e, "preferences");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <label className={styles.formGroup_label} htmlFor="jobTypes">
            Job type &#40;if more than one, separate with comma&#41;
          </label>
          <input
            id="jobTypes"
            name="jobTypes"
            className={styles.formGroup_input}
            type="text"
            placeholder="E.g Full-time, Part-time, Internship"
            onChange={(e) => {
              onChangeHandle(e, "preferences");
            }}
          />
        </div>
        <div className={styles.formGroup}>
          <button
            className={styles.formGroup_btn}
            onClick={(e) => {
              onSubmitHandle(e);
            }}
          >
            Update info
          </button>
        </div>
      </form>
    </section>
  );
};

export default DevUpdateForm;
